import axios from 'axios'

import {
    POPULATE_CHANNELS,
    POPULATE_CURRENT_USER_CHANNELS,
    RECEIVE_CHANNEL
} from './mutations'

export const FETCH_ALL_CHANNELS = 'FETCH_ALL_CHANNELS'
export const FETCH_CURRENT_USER_CHANNELS = 'FETCH_CURRENT_USER_CHANNELS'

export const CREATE_CHANNEL = 'CREATE_CHANNEL'
export const ARCHIVE_CHANNEL = 'ARCHIVE_CHANNEL'
export const REINSTATE_CHANNEL = 'REINSTATE_CHANNEL'

export const INIT = 'INIT'

export default {
    [INIT] ({ dispatch }) {
        dispatch(FETCH_CURRENT_USER_CHANNELS)
    },

    [FETCH_ALL_CHANNELS] ({ commit }) {
        axios.get('/api/channel?visibility=all')
            .then(response => {
                commit(POPULATE_CHANNELS, response.data.data)
            })
    },

    [FETCH_CURRENT_USER_CHANNELS] ({ commit }) {
        axios.get('/api/channel?visibility=member').then(response => {
            commit(POPULATE_CURRENT_USER_CHANNELS, response.data.data)
        })
    },

    [CREATE_CHANNEL] (context, form) {
        return form.post('/api/channel')
    },

    [ARCHIVE_CHANNEL] ({ commit }, channel) {
        return axios.post(`/api/channel/${channel.id}/archive`)
            .then(response => {
                commit(RECEIVE_CHANNEL, response.data.data)
            })
    },

    [REINSTATE_CHANNEL] ({ commit }, channel) {
        return axios.delete(`/api/channel/${channel.id}/archive`)
            .then(response => {
                commit(RECEIVE_CHANNEL, response.data.data)
            })
    },

    removeChannel ({ commit }, channelId) {
        return axios.delete(`/api/channel/${channelId}`).then(() => {
            commit('REMOVE_CHANNEL', channelId)
        })
    },

    removeDemoJobs () {
        return axios.delete(`/api/job/demo`)
    }
}
